import styled from 'styled-components';

const LabelNumber = styled.span`         
    // color:${({ theme }) => theme.NumberColor};
    text-align: right;
    font-feature-settings: 'clig' off, 'liga' off;
    /* DM-Mono/Title/Medium */
    font-family: "DM Mono";
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 100% */

    &.squad-number {        
        font-size: 24px;
        line-height: 24px; /* 100% */
        text-transform: uppercase;
    }
    
    &.injury-number{
     font-size: 24px;
       color: ${({ theme }) => theme.playerColor};
    }

    &.descriptive-text {
        color: ${({ theme }) => theme.ctaIconsColor};
        text-align: center;
        /* DM-Mono/Label/Small */
        font-size: 10px;
        line-height: 10px;
        /* 100% */
        text-transform: uppercase;
    }

     &.position-text {
        color: ${({ theme }) => theme.playerPositionLabel};
        text-align: center;
        font-size: 16px;
        font-family: "Aeonik";
        font-weight: 500;
        line-height: 20px;
        text-align: left;
        text-transform: sentencecase;
        margin-top: 4px;
    }

    &.descriptive-large-text {
        text-align: center;
        /* DM-Mono/Label/Small */
        font-size: 10px;
        line-height: 10px;
        /* 100% */
        text-transform: uppercase;
    }

    &.descriptive-large-value {
        color: ${({ theme }) => theme.playerColor};
        text-align: center;
    }

    &.range-text-color {
        color: var(--Brand-black-500, #111);
    }

    &.attack-defense-data {
        color: ${({ theme }) => theme.NumberColor}; 
        font-size: 14px;       
        line-height: 14px; /* 100% */
        text-transform: uppercase;
    }

    &.stat-row-value {
        color: #7C7D79;
        // color: ${({ theme }) => theme.playerColor};        
        font-size: 16px;
        line-height: 16px; /* 100% */
        text-transform: uppercase;
    }

    &.player-card-value{
        // color: ${({ theme }) => theme.playerColor};     
        font-size: 16px;
        line-height: 16px; /* 100% */
        text-transform: uppercase;
        position: relative;
        width: 100%;
    }

    &.average-percent {
        color: ${({ theme }) => theme.playerColor};        
        font-size: 48px;
        line-height: 48px; /* 100% */
        text-transform: uppercase;
    }

    &.chart-content-number {
        color: ${({ theme }) => theme.playerColor};
        font-size: 20px;
        line-height: 20px; /* 100% */
    }

    &.donut-chart-text{
        color: ${({ theme }) => theme.playerColor};
        font-size: 32px;
        line-height: 20px; /* 100% */
    }

    &.club-info-value {
        color: ${({ theme }) => theme.clubInfoValue};
        font-size: 16px;
        line-height: 16px; /* 100% */
        text-transform: uppercase;
    }
    &.total-games {
        font-size: 16px;       
        line-height: 16px; /* 100% */
        text-transform: uppercase;
    }
    &.injury-text {
        font-size: 14px;
        line-height: 14px; /* 100% */
        text-transform: uppercase;
    }
    &.season-text {
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px; /* 100% */
        text-transform: uppercase;
    }
    &.win-loss-info-text {
        color: ${({ theme }) => theme.matchLabel};
        text-align: center;
        leading-trim: both;
        text-edge: cap;
        font-size: 10px;
        font-weight: 500;
        line-height: 24.605px; /* 246.048% */
        letter-spacing: 0.246px;
}
        &.link{
            text-decoration : none;
        }
        &.event-player-card-details {
            color: ${({ theme }) => theme.playerColor};
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 12px; /* 100% */
            text-transform: uppercase;
        }
        &.match-win-info {
            color: ${({ theme }) => theme.playerDataTextColor};
            font-size: 10px;
            font-style: normal;
            font-weight: 500;
            line-height: 10px; /* 100% */
            text-transform: uppercase;

        }
        &.table-age-text{
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 14px; /* 100% */
            text-transform: uppercase;
            color: ${({ theme }) => theme.playerColor};
            text-align : left;
        }
        &.goal-assist-name {
            color: ${({ theme }) => theme.playerColor};
            font-size: 10px;
            font-style: normal;
            font-weight: 500;
            line-height: 10px; /* 100% */
            text-transform: uppercase;
        }
        &.score {
            color: var(--Brand-white-500, #FFF);
            text-align: center;
            font-size: 32px;
            font-style: normal;
            font-weight: 500;
            line-height: 32px; /* 100% */
            text-transform: uppercase;
        }
        &.percentile-text {
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 12px; /* 100% */
            text-transform: uppercase;
        }
        &.valuegraph-toggle-text{
            color: var(--Warm-Grey-warm-grey-600, #7C7D79);
            font-family: "DM Mono";
            font-size: 10px;
            font-style: normal;
            font-weight: 500;
            line-height: 10px; /* 100% */
            text-transform: uppercase;
        }
        &.playing-stats-data{
            color: ${({ theme }) => theme.playerColor};
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
        }
        &.toggle-style-text {
            color :#7C7D79;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 12px; /* 100% */
            text-transform: uppercase;
        }
        &.negative-difference {
            color:  #FF3864;
        }
            
        &.positive-difference {
            color: #00D1A8;
        }
        &.playerlist-name{
            color: ${({ theme }) => theme.playerColor};        
            font-size: 16px;
            line-height: 16px; /* 100% */
            text-transform: uppercase;
            font-weight: 500;

        }

`;

export default LabelNumber;